import { UserMultifactorStatus, UserStatus } from '@/constants/users';

/**
 * Gets the full name of a user.
 * @param {Object} user - The user object.
 * @returns {String} The full name.
 */
export const getUserName = (user) => {
  const { given_name, family_name, username } = user;
  if (!given_name || !family_name) {
    return username ? username : 'N/A';
  }
  return `${given_name} ${family_name}`;
};

/**
 * Gets the status of a user.
 * @param {Object} user - The user object.
 * @returns {UserStatus} The status.
 */
export const getUserStatus = (user) => {
  return user?.blocked ? UserStatus.BLOCKED : UserStatus.ACTIVE;
};

/**
 * Gets the authentication factor of a user.
 * @param {String | Array<String>} factor - The factor object.
 * @returns {UserMultifactorStatus} The multifactor authentication status.
 */
export const getUserMultifactorStatus = (factor) => {
  if (!factor) return UserMultifactorStatus.DISABLED;
  if (Array.isArray(factor) && factor.length === 0) {
    return UserMultifactorStatus.DISABLED;
  }
  return UserMultifactorStatus.ENABLED;
};

/**
 * Gets the username from an email address.
 * @param {String} email - The email address.
 * @returns {String} The username.
 */
export const getUsernameFromEmail = (email) => {
  if (!email) return '';
  const username = email.replace('@', '-');
  const topLevelDomainRegex = /\..*$/;
  return username.replace(topLevelDomainRegex, '');
};
